import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=4347daa2&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=4347daa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4347daa2",
  null
  
)

export default component.exports